export enum PowerOutputType {
  LOAD = 'load',
  LOADBANK = 'loadbank',
  SOLAR = 'solar',
  GENERATOR = 'generator',
}

export enum PowerOutputStatus {
  ACTIVE = 'active',
  BUSY = 'busy',
  ERROR = 'error',
  IDLE = 'idle',
  UNKNOWN = 'unknown',
}

export type PowerOutputDetail = {
  label: string;
  value: string | number | null | undefined;
  showStatusDot?: boolean;
  dotColor?: string;
};

export type PowerOutput = {
  id?: string | number;
  name: string;
  type: PowerOutputType;
  status?: PowerOutputStatus;
  isEnergized?: boolean;
  details?: PowerOutputDetail[];
};

export const isPowerOutputActive = (status?: PowerOutputStatus): boolean => status === PowerOutputStatus.ACTIVE;
